import { DateTime } from "luxon";

// Vencimiento de insumos. Las fechas viajan como "YYYY-MM-DD" (columnas `date`),
// así que se comparan como strings en el día local del usuario.

export const todayISODate = () => DateTime.local().toISODate();

// Fecha de alerta sugerida: `months` meses antes del vencimiento (acepta 1.5).
export const suggestAlertDate = (expirationDate, months) => {
  const exp = DateTime.fromISO(expirationDate || "");
  if (!exp.isValid) return "";
  const whole = Math.floor(months);
  const days = Math.round((months - whole) * 30);
  return exp.minus({ months: whole, days }).toISODate();
};

// Estado de un insumo: "expired" | "expiring" (alerta alcanzada) | "ok" | null (sin vencimiento).
export const getExpirationStatus = (supply, today = todayISODate()) => {
  const exp = supply?.expiration_date;
  if (!exp) return null;
  if (exp <= today) return "expired";
  if ((supply.expiration_alert_date || exp) <= today) return "expiring";
  return "ok";
};

export const formatDateOnly = (value) => {
  const d = DateTime.fromISO(value || "");
  return d.isValid ? d.toLocaleString(DateTime.DATE_SHORT) : "—";
};
